import { queryOptions } from "@tanstack/react-query";
import type { InferResponseType } from "hono/client";
import { api, unwrap } from "@/client/lib/api";

const list = api.tasks[":id"].comments.$get;

export type CommentRow = InferResponseType<typeof list, 200>["items"][number];

export type CommentImage = CommentRow["images"][number];

/** A task's comments, oldest first. */
export const commentsQuery = (taskId: string) =>
  queryOptions({
    queryKey: ["task", taskId, "comments"],
    queryFn: (): Promise<CommentRow[]> =>
      unwrap(list({ param: { id: taskId } })).then(({ items }) => items),
  });

/** A comment still being sent carries this tab's own copy of each image in place of its key. */
export const imageAt = (key: string) =>
  key.startsWith("blob:") ? key : `/api/images/${key}`;
